import React from 'react'
import CaluInput from '@/components/styledComponents/CaluInput'
import { Grid } from '@mui/material'

import s from './styles.module.scss'

const AdminPatientsSearchBar = ({ inputSearch, setInputSearch }) => {
  return (
    <Grid container className={s.mainContainer}>
      <Grid item xs={12} md={4}>
        <CaluInput
          id="search"
          type="text"
          autoComplete="off"
          labelText="Buscar paciente"
          value={inputSearch}
          onChange={(e) => setInputSearch(e.target.value)}
          className={s.searchBarContainer}
        />
      </Grid>
    </Grid>
  )
}

export default AdminPatientsSearchBar
